import React, { useState } from "react";
import { Col, Button, Container } from "reactstrap";
//import Plaque from "../../documents/Plaque.png";
import Lobby from "../../documents/lobbyfinal.jpg";

const Home = () => {
  const [hoveredButton, setHoveredButton] = useState(null);

  let links = [
 ["Proxy Voting Record", "proxy"],
    ["IRS Form 8937: Congress SMid Core Opportunity Fund - Fund reorganization",
      "irs",],
    ["New Account Application (Non-Retirement Accounts)", "newAcc"],
    ["IRA Application (For Traditional, ROTH, SEP, and SIMPLE IRAs)", "iraApp"],
    ["IRA Transfer Form", "iraTransfer"],
    ["IRA Disclosure", "iraDisclosure"],
    ["Coverdell Education Savings Account Application", "coverdell"],
    ["New Account Application for Legal Entities", "newAccLegal"],
    ["Certification of Beneficial Owners Form", "certification"],
  ];

  // Function to handle mouse enter event
  const handleMouseEnter = (index) => {
    setHoveredButton(index);
  };

  // Function to handle mouse leave event
  const handleMouseLeave = () => {
    setHoveredButton(null);
  };

  const linkStyle = {
    textDecoration: 'none', // Remove underline
  };

  const linkHoverStyle = {
    textDecoration: 'underline', // Add underline on hover
    color: '#3486eb'
  };

  return (
    <div>
      <div
        style={{
          height: "0",
          width: "100%",
          paddingBottom: "350px",
        }}
      >
        <img
          style={{
            objectFit: 'cover', width: '100%', height: 600
          }}
          alt="plaque"
          src={Lobby}
        />

      </div>
      <h1 style={{ position: "absolute", top: 490, fontWeight: 'bold', paddingLeft: "8%", color: "#2184bd", fontSize: "calc(4vw + 4vh)" }}>
        Congress Mutual Funds
      </h1>
      <Col
        className="text-center"
        style={{ marginTop: "270px", color: "#2c5e85", fontSize: "240%", marginBottom: "50px" }}>
        <p>Learn more about our mutual funds</p>
        <Container
          style={{ padding: "5px" }}
          className="d-flex flex-row justify-content-center"
          id="links"
        >
          {["Small", "Mid", "Large"].map((capRange, index) => (
            <React.Fragment key={capRange}>
              <Button
                key={capRange}
                style={{
                  fontFamily: "Aptos", border: "rgb(0, 0, 0, 0)", backgroundColor: "rgb(0, 0, 0, 0)", color: "#0691d1", // Apply bold styling based on state
                  transition: 'font-size 0.3s ease', fontSize: hoveredButton === index ? '70%' : '50%'
                }}
                className="m-1"
                href={`/${capRange}Cap`}
                onMouseEnter={() => handleMouseEnter(index)} // Set hover state
                onMouseLeave={handleMouseLeave} // Reset hover state
              >
                {capRange} Cap Growth
              </Button>
              {(capRange !== "Large") && <div style={{ height: '30px', borderLeft: '2px solid orange', margin: '0 10px', alignSelf: 'center' }} />}
            </React.Fragment>
          ))}
        </Container>

        <div style={{ display: 'flex' }}>
          <div style={{ flex: 1, padding: 20, border: 5 }}>
            <h2>Contact Us</h2>
            <a style={{ color: "#2c5e85", fontSize: "60%" }} href="tel:18886881299"> Shareholder Services | 1-888-688-1299</a>
          </div>
          <div style={{ flex: 1, padding: 20, border: 5 }}>
            <h2>Shareholder Resources</h2>
            {links.map((link) => (
              <a
                href={link[1]}
                key={link[0]}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#0691d1", textDecoration: 'none', textAlign: "left", fontSize: "40%", display: "block" }}
                onMouseOver={(e) => e.currentTarget.style.textDecoration = linkHoverStyle.textDecoration}
                onMouseOut={(e) => e.currentTarget.style.textDecoration = linkStyle.textDecoration}
              >
                {link[0]}
              </a>
            ))}
          </div>
        </div>
      </Col>
    </div>
  );
};

export default Home;
